import React from "react";
import { Container } from "reactstrap";

const StaticHeaderInfo = (props: any) => (
  <div className="bg-primary-one header-Info-height d-flex flex-column-reverse align-items-start pb-4">
    <Container>{props.children}</Container>
  </div>
);

export default StaticHeaderInfo;
